export enum EventAttributeDropdownType {
    dropdown = 0,
    radioButton = 1
}